import { z } from 'zod';
// Letters + spaces only. Hyphens are transformed away before validation.
// Apostrophes, accents, digits, and all other punctuation are rejected —
// GDS / airlines cannot process them in passenger names.
export const PERSON_NAME_REGEX = /^[a-zA-Z ]+$/;
export const PERSON_NAME_ERROR = 'Ce champ ne doit contenir que des lettres sans accent ni ponctuation (apostrophes et caractères spéciaux interdits).';
export function sanitizePersonName(value) {
    if (typeof value !== 'string')
        return value;
    return value.replace(/-/g, ' ').replace(/\s+/g, ' ').trim();
}
const personNameBase = z.preprocess(sanitizePersonName, z.string().min(1).regex(PERSON_NAME_REGEX, PERSON_NAME_ERROR));
const personNameOptional = personNameBase.optional();
export function personName(options = {}) {
    return options.optional ? personNameOptional : personNameBase;
}
